/**
 * Extract a human-readable error message from any thrown value.
 *
 * Prefers, in order:
 *   1. `response.data.error`  (our backoffice/Laravel "error" key)
 *   2. `response.data.message` (default Laravel message)
 *   3. First message in `response.data.errors` (validation arrays)
 *   4. `err.message` (standard JS Error)
 *   5. fallback
 */
export const extractErrorMessage = (err: unknown, fallback: string): string => {
  if (err && typeof err === 'object' && 'response' in err) {
    const response = (err as { response?: { data?: unknown; status?: number } }).response;
    const data = response?.data as
      | { error?: string; message?: string; errors?: Record<string, string[] | string> }
      | undefined;

    if (data) {
      if (typeof data.error === 'string' && data.error.trim()) return data.error;
      if (typeof data.message === 'string' && data.message.trim()) return data.message;
      if (data.errors && typeof data.errors === 'object') {
        const first = Object.values(data.errors)[0];
        if (Array.isArray(first) && typeof first[0] === 'string') return first[0];
        if (typeof first === 'string') return first;
      }
    }
  }
  if (err instanceof Error && err.message) return err.message;
  return fallback;
};
